export default __webpack_public_path__ + "static/media/delete.a2532cc9.svg";